<template>
    <v-container>
        <v-overlay v-if="loading">
            <v-progress-circular size="100" width="5" color="primary" indeterminate />
        </v-overlay>
        <template v-if="data">
            <interview-view-auth />
            <interview-view-join />
            <interview-view-room />
            <interview-view-seek />
        </template>
    </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

import InterviewViewAuth from "@/components/interview/view/interview-view-auth.vue";
import InterviewViewJoin from "@/components/interview/view/interview-view-join.vue";
import InterviewViewRoom from "@/components/interview/view/interview-view-room.vue";
import InterviewViewSeek from "@/components/interview/view/interview-view-seek.vue";

export default {
    components: {
        InterviewViewAuth,
        InterviewViewJoin,
        InterviewViewRoom,
        InterviewViewSeek,
    },
    props: {
        code: { type: String, default: null },
    },
    computed: {
        ...mapState("interview", ["loading", "data"]),
    },
    methods: {
        ...mapActions("interview", ["getData"]),

        init() {
            let { code } = this;
            this.getData({ code });
        },
    },
    watch: {
        code() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style>
</style>